import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import {
  HttpClient,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AppLoadingService } from '../common/loading.service';

@Injectable()
export class ElectricityService {
  hostUrl: any = environment.ELECTRICITY_API_URL;
  urlToGetCompanies: any = this.hostUrl + 'api/getCompanies';
  urlToGetPlansOfCompany: any = this.hostUrl + 'api/getUniquePlans';
  urlToGetAllPlanCountsForCompany: any = this.hostUrl + 'api/getPlanCountforCompany';
  urlToGetAllPlanCounts: any = this.hostUrl + 'api/getPlanCountsAll';
  urlToGetPlansOfLike: any = this.hostUrl + 'api/getPlansoflike';
  urlToGetAllTdus: any = this.hostUrl + 'api/getAllTdus';
  urlToGetCompanyRating: any = this.hostUrl + 'api/getCompaniesRating';
  urlToApplyConfigToOnePlan: any = this.hostUrl + 'api/applyConfig';
  urlToApplyConfigToAllPlan: any = this.hostUrl + 'api/applyConfigAll';
  urlToFlagPlan: any = this.hostUrl + 'api/flagPlan';
  urlToGetBestPlan: any = this.hostUrl + 'api/bestplan';
  urlToGetPlanPerState: any = this.hostUrl + 'api/plansPerState';
  urlToGetTexasPlansTest: any = this.hostUrl + 'api/getPlansTest';

  constructor(private _http: HttpClient) {}

  getBestPlan(data): Observable<any> {
    return this._http.post(this.urlToGetBestPlan, data).map((res: Response) => res);
  }

  getAllCompanies(): Observable<any> {
    return this._http.get(this.urlToGetCompanies).map((res: Response) => res);
  }

  getAllPlanOfCompany(data): Observable<any> {
    return this._http.post(this.urlToGetPlansOfCompany, data).map((res: Response) => res);
  }

  getAllPlansOfLike(data): Observable<any> {
    return this._http.post(this.urlToGetPlansOfLike, data).map((res: Response) => res);
  }

  getAllPlanCountsForCompany(data): Observable<any> {
    return this._http.post(this.urlToGetAllPlanCountsForCompany, data).map((res: Response) => res);
  }

  getAllPlanCounts(): Observable<any> {
    return this._http.get(this.urlToGetAllPlanCounts).map((res: Response) => res);
  }

  getAllTDUsName(): Observable<any> {
    return this._http.get(this.urlToGetAllTdus).map((res: Response) => res);
  }

  getAllCompanyRating(): Observable<any> {
    return this._http.get(this.urlToGetCompanyRating).map((res: Response) => res);
  }

  getPlanPerState(data): Observable<any> {
    return this._http.post(this.urlToGetPlanPerState, data).map((res: Response) => res);
  }

  applyConfigToPlan(data): Observable<any> {
    return this._http.post(this.urlToApplyConfigToOnePlan, data).map((res: Response) => res);
  }

  applyConfigToAllPlan(data): Observable<any> {
    return this._http.post(this.urlToApplyConfigToAllPlan, data).map((res: Response) => res);
  }
  flagPlan(data): Observable<any> {
    return this._http.post(this.urlToFlagPlan, data).map((res: Response) => res);
  }

  getTexasPlans(option, env): Observable<any> {
    return this._http
      .post('http://localhost:8080/api/getPlansTest', {
        isFailed: option,
        env: env
      })
      .map((res: Response) => res);
  }

  setStatusTexasPlans(planId, verified, env): Observable<any> {
    return this._http
      .post('http://localhost:8080/api/setVerify', {
        planId: planId,
        verified: verified,
        env: env
      })
      .map((res: Response) => res);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/main/electricity.service.ts